<script  >
    import {currentLanguage, Language} from "./stores/store";
    import router from 'page'
    import Menu from "./comps/GeneralPage/Menu.svelte";
    import Bannerhome from "./comps/GeneralPage/Bannerhome.svelte";
    import CallToAction1 from "./comps/GeneralPage/CallToAction1.svelte";
    import CallToAction2 from "./comps/GeneralPage/CallToAction2.svelte";
    import Section4items from "./comps/GeneralPage/Section4items.svelte";
    import DisplayWide from "./comps/GeneralPage/DisplayWide.svelte";
    import Section6Items from "./comps/GeneralPage/Section6Items.svelte";
    import SectionBlueWide from "./comps/GeneralPage/SectionBlueWide.svelte";
    import VideoBg from "./comps/GeneralPage/VideoBg.svelte";
    import NewFooter from "./comps/GeneralPage/NewFooter.svelte";
    import DeferredSources from "./comps/GeneralPage/DeferredSources.svelte";
    import Toki from "./comps/GeneralPage/Toki.svelte";

    let i18n = $Language[$currentLanguage];
    $:i18n = $Language[$currentLanguage];
    let debug = false;

    router('/it', () => {
        currentLanguage.update(n => 0);
    });
    router('/en', () => {
        currentLanguage.update(n => 1);
    });
    router('/', () => {
                if (debug) {
                    return;
                }
                let userLang = navigator.language || navigator.userLanguage;
                console.log(userLang);
                if (!userLang.includes('it')) {
                    router.redirect('/en');
                } else {
                    router.redirect('/it');
                }
            }
    );
    router.start();
    export let name;
</script>
<DeferredSources sources={[
    {rel:'stylesheet',href:'/fontawesome/css/all.min.css',timeout:1000}
    ]}/>
<Menu   text1="{i18n['Menu'][0]['text1']}"
        text2="{i18n['Menu'][0]['text2']}"
        text3="{i18n['Menu'][0]['text3']}"
        text4="{i18n['Menu'][0]['text4']}"
        menulinkWeb="{i18n['Menu'][0]['menulinkWeb']}" menulinkhardware="{i18n['Menu'][0]['menulinkhardware']}"
      menulinkautomation="{i18n['Menu'][0]['menulinkautomation']}"
      menulinkCont="{i18n['Menu'][0]['menulinkCont']}"></Menu>
<section class="{i18n['section'][0]['class']}">
    <div class="{i18n['div'][0]['class']}"></div>
    <VideoBg urls="{i18n['VideoBg'][0]['urls']}" start="{i18n['VideoBg'][0]['start']}"
             noMobile="{i18n['VideoBg'][0]['noMobile']}"></VideoBg>
    <Bannerhome firstitleh5="{i18n['Bannerhome'][0]['firstitleh5']}" title="{i18n['Bannerhome'][0]['title']}"
                subtitle="{i18n['Bannerhome'][0]['subtitle']}" btn1Text="{i18n['Bannerhome'][0]['btn1Text']}"
                btn1Href="{i18n['Bannerhome'][0]['btn1Href']}" btn2Text="{i18n['Bannerhome'][0]['btn2Text']}"
                btn2Href="{i18n['Bannerhome'][0]['btn2Href']}"></Bannerhome>
    <div class="{i18n['div'][1]['class']}"></div>
</section><span class="{i18n['span'][0]['class']}" id="{i18n['span'][0]['id']}"></span>
<SectionBlueWide Title="{i18n['SectionBlueWide'][0]['Title']}"
                 subTitle="{i18n['SectionBlueWide'][0]['subTitle']}"></SectionBlueWide>
<section>
    <VideoBg urls="{i18n['VideoBg'][1]['urls']}"></VideoBg>
    <Section6Items icon1="{i18n['Section6Items'][0]['icon1']}"
                   sectionTitle1="{i18n['Section6Items'][0]['sectionTitle1']}"
                   subtitle1="{i18n['Section6Items'][0]['subtitle1']}"
                   subtitle11="{i18n['Section6Items'][0]['subtitle11']}" icon2="{i18n['Section6Items'][0]['icon2']}"
                   title2="{i18n['Section6Items'][0]['title2']}" subtitle2="{i18n['Section6Items'][0]['subtitle2']}"
                   icon3="{i18n['Section6Items'][0]['icon3']}"
                   sectionTitle2="{i18n['Section6Items'][0]['sectionTitle2']}"
                   subtitle3="{i18n['Section6Items'][0]['subtitle3']}"
                   subtitle33="{i18n['Section6Items'][0]['subtitle33']}" icon4="{i18n['Section6Items'][0]['icon4']}"
                   title4="{i18n['Section6Items'][0]['title4']}" subtitle4="{i18n['Section6Items'][0]['subtitle4']}"
                   icon5="{i18n['Section6Items'][0]['icon5']}" title5="{i18n['Section6Items'][0]['title5']}"
                   subtitle5="{i18n['Section6Items'][0]['subtitle5']}" icon6="{i18n['Section6Items'][0]['icon6']}"
                   title6="{i18n['Section6Items'][0]['title6']}"
                   subtitle6="{i18n['Section6Items'][0]['subtitle6']}"></Section6Items>
</section>
<div class="{i18n['div'][2]['class']}"></div>
<DisplayWide Title="{i18n['DisplayWide'][0]['Title']}" subTitle="{i18n['DisplayWide'][0]['subTitle']}"
             link="{i18n['DisplayWide'][0]['link']}" textButton="{i18n['DisplayWide'][0]['textButton']}"
             img="{i18n['DisplayWide'][0]['img']}"></DisplayWide>
<CallToAction1 Text="{i18n['CallToAction1'][0]['Text']}"
               subText="{i18n['CallToAction1'][0]['subText']}"
               phoneText="{i18n['CallToAction1'][0]['phoneText']}"
></CallToAction1><span class="{i18n['span'][1]['class']}"
                                                                                     id="{i18n['span'][1]['id']}"></span>
<SectionBlueWide Title="{i18n['SectionBlueWide'][1]['Title']}"
                 subTitle="{i18n['SectionBlueWide'][1]['subTitle']}"></SectionBlueWide>
<section class="{i18n['section'][1]['class']}">
    <VideoBg urls="{i18n['VideoBg'][2]['urls']}"></VideoBg>
    <Section4items icon1="{i18n['Section4items'][0]['icon1']}" title1="{i18n['Section4items'][0]['title1']}"
                   subtitle1="{i18n['Section4items'][0]['subtitle1']}" icon2="{i18n['Section4items'][0]['icon2']}"
                   title2="{i18n['Section4items'][0]['title2']}" subtitle2="{i18n['Section4items'][0]['subtitle2']}"
                   icon3="{i18n['Section4items'][0]['icon3']}" title3="{i18n['Section4items'][0]['title3']}"
                   subtitle3="{i18n['Section4items'][0]['subtitle3']}" icon4="{i18n['Section4items'][0]['icon4']}"
                   title4="{i18n['Section4items'][0]['title4']}" subtitle4="{i18n['Section4items'][0]['subtitle4']}"
                   Img="{i18n['Section4items'][0]['Img']}" imgLink="{i18n['Section4items'][0]['imgLink']}"
                   altimags4="{i18n['Section4items'][0]['altimags4']}"
                   imgDescription="{i18n['Section4items'][0]['imgDescription']}"
                   textfollowlink1="{i18n['Section4items'][0]['textfollowlink1']}"></Section4items>
</section>
<CallToAction1 Text="{i18n['CallToAction1'][1]['Text']}"
               subText="{i18n['CallToAction1'][1]['subText']}"
               phoneText="{i18n['CallToAction1'][1]['phoneText']}"
></CallToAction1><span class="{i18n['span'][2]['class']}"
                                                                                     id="{i18n['span'][2]['id']}"></span>
<SectionBlueWide Title="{i18n['SectionBlueWide'][2]['Title']}"
                 subTitle="{i18n['SectionBlueWide'][2]['subTitle']}"></SectionBlueWide>
<section class="{i18n['section'][2]['class']}">
    <VideoBg urls="{i18n['VideoBg'][3]['urls']}"></VideoBg>
    <Section4items icon1="{i18n['Section4items'][1]['icon1']}" title1="{i18n['Section4items'][1]['title1']}"
                   subtitle1="{i18n['Section4items'][1]['subtitle1']}" icon2="{i18n['Section4items'][1]['icon2']}"
                   title2="{i18n['Section4items'][1]['title2']}" subtitle2="{i18n['Section4items'][1]['subtitle2']}"
                   icon3="{i18n['Section4items'][1]['icon3']}" title3="{i18n['Section4items'][1]['title3']}"
                   subtitle3="{i18n['Section4items'][1]['subtitle3']}" icon4="{i18n['Section4items'][1]['icon4']}"
                   title4="{i18n['Section4items'][1]['title4']}" subtitle4="{i18n['Section4items'][1]['subtitle4']}"
                   Img="{i18n['Section4items'][1]['Img']}" imgLink="{i18n['Section4items'][1]['imgLink']}"
                   altimags4="{i18n['Section4items'][1]['altimags4']}"
                   imgDescription="{i18n['Section4items'][1]['imgDescription']}"
                   textfollowlink1="{i18n['Section4items'][0]['textfollowlink1']}"
                   reverseOrder="{i18n['Section4items'][1]['reverseOrder']}"></Section4items>
</section><span class="{i18n['span'][3]['class']}" id="{i18n['span'][3]['id']}"></span>
<CallToAction2 Text="{i18n['CallToAction2'][0]['Text']}"
               subText="{i18n['CallToAction2'][0]['subText']}"
                sendText="{i18n['CallToAction2'][0]['sendText']}"
                greetingSubText="{i18n['CallToAction2'][0]['greetingSubText']}"
                greetingText="{i18n['CallToAction2'][0]['greetingText']}"
               TextForm="{i18n['CallToAction2'][0]['TextForm']}"
               form="{i18n['CallToAction2'][0]['form']}"
               loadingText="{i18n['CallToAction2'][0]['loadingText']}"
               formIncopleteText="{i18n['CallToAction2'][0]['formIncopleteText']}"
               phoneText="{i18n['CallToAction2'][0]['phoneText']}"
></CallToAction2><div class="{i18n['div'][3]['class']}"></div>
<NewFooter namelogo="{i18n['NewFooter'][0]['namelogo']}" descriptionus="{i18n['NewFooter'][0]['descriptionus']}"
           menuTextAutomation="{i18n['NewFooter'][0]['menuTextAutomation']}"
           menuTextContact="{i18n['NewFooter'][0]['menuTextContact']}"
           TextContact="{i18n['NewFooter'][0]['TextContact']}" phone="{i18n['NewFooter'][0]['phone']}"
           address="{i18n['NewFooter'][0]['address']}"
></NewFooter>

<Toki text={i18n['Toki'][0]['text']}></Toki>

<style lang="scss">:global(.scroll) {
        overflow-y:scroll;
        max-height: 66vh;
    }

    :global(iframe[title="Toky Call Button"]) {
        display: none;
    };

    :global(html) {
        scroll-behavior: smooth;
    }

    :global(body) {
        margin: 0!important;
        padding: 0!important;
        overflow-x: hidden;
        * {
            line-height: 1.6em;
        }
        width: 100%;
    }

    main {
        text-align: center;
        padding: 1em;
        max-width: 240px;
        margin: 0 auto;
    }

    h1 {
        color: #ff3e00;
        text-transform: uppercase;
        font-size: 4em;
        font-weight: 100;
    }

    .link {
        position: absolute;
        transform: translateY(-30vh);
    }

    .bgFallback {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: black;
    }

    section {
        position: relative;
        overflow: hidden;
    }

    @media (min-width: 640px) {
        main {
            max-width: none;
        }
    }</style>
